module.exports = __webpack_public_path__ + "static/img/trends3.74cbc3ba.webp";